<template>
  <search-suggestions-form :data="suggestion"
                           :title="$t('searchSuggestions.edit.title', { name: suggestion ? suggestion.keyword : ''})"
                           :submit-loading="submitLoading"
                           @submit="onSubmit">
  </search-suggestions-form>
</template>
<script>
  import SearchSuggestionsForm from './SearchSuggestionsForm'
  import SearchSuggestionsService from 'src/services/SearchSuggestionsService'
  import LanguageSelect from 'src/components/LanguageSelect'

  export default {
    components: {
      LanguageSelect,
      SearchSuggestionsForm,
    },
    data () {
      return {
        submitLoading: false,
        suggestion: null,
      }
    },
    methods: {
      async getData () {
        let {data} = await SearchSuggestionsService.getById(this.$route.params.id)
        this.suggestion = data
      },
      async onSubmit (data) {
        try {
          this.submitLoading = true
          await SearchSuggestionsService.update(data.id, data)
          this.$router.push('/settings/search-suggestions')
        } finally {
          this.submitLoading = false
        }
      },
    },
    watch: {
      '$store.state.config.textLanguage' () {
        this.getData()
      },
    },
    async created () {
      await this.getData()
    }
  }
</script>
<style>
</style>
